/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InviteCollaborator_inviteCollaborator_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly createAsAdmin: boolean | null };

export type InviteCollaborator_Mutation = { readonly __typename: 'Mutation', readonly inviteCollaborator: ReadonlyArray<InviteCollaborator_inviteCollaborator_CreditApplicationPerson> | null };


export type InviteCollaboratorVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['ID']['input'];
  collaborator: _Types.PersonInput;
}>;


export type InviteCollaborator = InviteCollaborator_Mutation;


export const InviteCollaboratorDocument = gql`
    mutation InviteCollaborator($salesforceCreditId: ID!, $collaborator: PersonInput!) {
  inviteCollaborator(
    salesforceCreditId: $salesforceCreditId
    collaborator: $collaborator
  ) {
    id
    firstName
    lastName
    email
    createAsAdmin
  }
}
    `;
export type InviteCollaboratorMutationFn = Apollo.MutationFunction<InviteCollaborator, InviteCollaboratorVariables>;

/**
 * __useInviteCollaborator__
 *
 * To run a mutation, you first call `useInviteCollaborator` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCollaborator` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCollaborator, { data, loading, error }] = useInviteCollaborator({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *      collaborator: // value for 'collaborator'
 *   },
 * });
 */
export function useInviteCollaborator(baseOptions?: Apollo.MutationHookOptions<InviteCollaborator, InviteCollaboratorVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCollaborator, InviteCollaboratorVariables>(InviteCollaboratorDocument, options);
      }
export type InviteCollaboratorHookResult = ReturnType<typeof useInviteCollaborator>;
export type InviteCollaboratorMutationResult = Apollo.MutationResult<InviteCollaborator>;
export type InviteCollaboratorMutationOptions = Apollo.BaseMutationOptions<InviteCollaborator, InviteCollaboratorVariables>;